import React, { useEffect } from "react";
import { Dialog } from "@material-ui/core";
import { CloseIcon, FlightTakeoffIcon } from "@icarius-icons";
import EmployeeVacationsDialogContent from "@icarius-pages/vacations/components/employeeVacationsDialog/content";
import PaperDraggable from "@icarius-common/paperDraggable";
import PlayButton from "@icarius-common/audioPlayer/components/playButton";
import { getUserData } from "@icarius-app/selectors";
import { useSelector } from "react-redux";
import useVisitPage from "@icarius-utils/hooks/useVisitPage";
import paths from "@icarius-router/paths";
import {
    getEmployeeMiscData,
    getIsLoading,
    getDateFormat,
    getEmployeeDebitData,
    getEmployeeCreditData,
    getVacationsUpdateDate,
    getContractDate,
} from "@icarius-pages/vacations/selectors";
import Loader from "@icarius-common/loader";
import { useHistory } from "react-router-dom";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { loading as loadingRequests } from "@icarius-pages/myRequests/selectors";
import DialogTransition from "@icarius-common/dialogTransition";
import { getEmployeeVacationsAction } from "@icarius-pages/vacations/actions";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { requestsIds } from "@icarius-utils/requestsIds";

const MyVacationsDialog = ({ open, handleClose }) => {
    const dispatch = useDispatch();

    const requestsIsLoading = useSelector(loadingRequests);
    const isLoading = useSelector(getIsLoading);
    const dateFormat = useSelector(getDateFormat);
    const debitData = useSelector(getEmployeeDebitData);
    const creditData = useSelector(getEmployeeCreditData);
    const miscData = useSelector(getEmployeeMiscData);
    const vacationsUpdateDate = useSelector(getVacationsUpdateDate);
    const contractDate = useSelector(getContractDate);

    const playAudioTitle = (
        <PlayButton
            audioName="Mi cuenta corriente de vacaciones"
            title={getLocalizedString("myVacationCurrentAccount")}
        />
    );
    const userData = useSelector(getUserData);

    const history = useHistory();

    useEffect(() => {
        if (userData.level === "C") {
            dispatch(getEmployeeVacationsAction(userData.level));
        }
    }, [dispatch, userData]);

    useVisitPage(paths.myVacations);

    const handleVacationsClick = () => {
        history.push({
            pathname: paths.myRequests,
            search: `?type=${requestsIds.holidays}`,
        });
    };

    const vacationRequestButton = () => (
        <CustomIconButton title={getLocalizedString("requestVacations")} onClick={handleVacationsClick}>
            <FlightTakeoffIcon />
        </CustomIconButton>
    );

    if (isLoading) {
        return <Loader open={isLoading} />;
    }

    return (
        <Dialog
            TransitionComponent={DialogTransition}
            PaperComponent={PaperDraggable}
            open={open}
            scroll={"paper"}
            fullWidth={true}
            maxWidth={"xl"}
        >
            <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
            <Loader open={requestsIsLoading} />
            <EmployeeVacationsDialogContent
                dateFormat={dateFormat}
                creditData={creditData}
                debitData={debitData}
                miscData={miscData}
                playAudioTitle={playAudioTitle}
                employeeCode={userData.code}
                vacationRequestButton={vacationRequestButton}
                vacationsUpdateDate={vacationsUpdateDate}
                contractDate={contractDate}
            />
        </Dialog>
    );
};

export default MyVacationsDialog;
